/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Connectionstatus_Unknown1Inputs */



/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Alarms_Connectionstatus_Unknown1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_connectionstatus_unknown1 = /** @type {((inputs?: Alarms_Connectionstatus_Unknown1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Connectionstatus_Unknown1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unknown")
	return /** @type {LocalizedString} */ ("Inconnu")
});
export { alarms_connectionstatus_unknown1 as "alarms_connectionStatus_unknown" }